<div class="error-container">
  <img src="../../../assets/images/not-found.gif" alt="Not Found">
  <h1>Опа! Страницата не е намерена...</h1>
  <p>Съжалявам, но страницата която търсите не съществува.</p>
  <a [routerLink]="['']" class="btn btn-primary">Към началото</a>
</div>